<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog :title="title" :visible.sync="isChange" width="40%" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<el-form :model="isXx" :rules="rules" ref="isXx" label-width="150px">
				<el-form-item prop="roomNum" label="房间号">
					<el-input v-model="isXx.roomNum"></el-input>
				</el-form-item>
				<el-form-item prop="name" label="住户">
					<el-input v-model="isXx.name"></el-input>
				</el-form-item>
				<el-form-item prop="phone" label="手机号">
					<el-input v-model="isXx.phone"></el-input>
				</el-form-item>
				<el-form-item prop="carNum" label="车牌号">
					<el-input v-model="isXx.carNum"></el-input>
				</el-form-item>
				<el-form-item prop="spaceNum" label="车位号">
					<el-input v-model="isXx.spaceNum"></el-input>
				</el-form-item>
				<el-form-item prop="rent" label="租金(月/元)">
					<el-input v-model="isXx.rent"></el-input>
				</el-form-item>
				<el-form-item label="租赁时长">
					<el-date-picker v-model="isXx.startTime" type="date" placeholder="选择开始日期"
					value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					<span>-</span>
					<el-date-picker v-model="isXx.endTime" type="date" placeholder="选择结束日期"
					value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
		<!-- tab页 -->
		<el-tabs v-model="activeName" @tab-click="query()">

			<el-tab-pane label="停车缴费记录" name="2">
				<div>
					<el-form :inline="true" :model="tcSelect" ref="tcSelect">
						<el-form-item label="时间：">
							<el-date-picker v-model="tcSelect.startTime" type="datetime" placeholder="选择入场日期"
							value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
							<span>-</span>
							<el-date-picker v-model="tcSelect.endTime" type="datetime" placeholder="选择日期"
							value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-form-item>
						<!--el-form-item label="停车场" prop="parkingLot">
								<el-select v-model="tcSelect.parkingLot">
									<el-option label="复兴大厦人才公寓地下停车场" value="复兴大厦人才公寓地下停车场"></el-option>
								</el-select>
							</el-form-item-->
						<el-form-item label="车牌号：" prop="carNum">
							<el-input v-model="tcSelect.carNum" placeholder="车牌号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getAll">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="goClear">重置</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="dc()">导出</el-button>
						</el-form-item>
						<el-form-item>
							<div style="font-size: 25px;">共计{{ totalNum }}条记录</div>
						</el-form-item>
						<el-form-item>
							<div style="font-size: 25px;">共计收费{{ sum }}元</div>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tcList" style="width: 100%" border v-loading="loading">
					<el-table-column prop="carNum" label="车牌号" align="center"></el-table-column>
					<!--el-table-column prop="parkingLot" label="停车场" align="center"></el-table-column-->
					<el-table-column prop="startTime" label="入场时间" align="center">
						<template slot-scope="{row}">
							{{ setTime(row.startTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="endTime" label="出场时间" align="center">
						<template slot-scope="{row}">
							{{ setTime(row.endTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="elapsedTime" label="停车时长(分钟)" align="center">
						<template slot-scope="{row}">
							{{ row.elapsedTime }}分
						</template>
					</el-table-column>
					<el-table-column prop="discountTime" label="优惠时长(分钟)" align="center">
						<template slot-scope="{row}">
							{{ row.discountTime != null ? row.discountTime : '0' }}
						</template>
					</el-table-column>
					<el-table-column prop="money" label="应缴金额(元)" align="center">
					</el-table-column>
					<el-table-column prop="discount" label="优惠金额(元)" align="center">
						<template slot-scope="{row}">
							{{ row.discount != null ? row.discount : '0' }}
						</template>
					</el-table-column>
					<el-table-column prop="amount" label="实缴金额(元)" align="center"></el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
					:page-size="tcSelect.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
					style="margin-top: 10px;">
				</el-pagination>
			</el-tab-pane>
			<el-tab-pane label="人才公寓车位租赁记录" name="1">
				<div>
					<el-form :inline="true" :model="selectForm" ref="selectForm">
            <el-form-item label="房间号：" prop="roomId">
							<el-input v-model="selectForm.roomId" placeholder="请输入房间号" clearable></el-input>
						</el-form-item>
						<el-form-item label="车主姓名：" prop="userName">
							<el-input v-model="selectForm.userName" placeholder="请输入车主名称" clearable></el-input>
						</el-form-item>
						<!-- <el-form-item label="手机号：" prop="userPhone">
							<el-input v-model="selectForm.userPhone" placeholder="手机号"></el-input>
						</el-form-item> -->
						<el-form-item label="车牌号：" prop="carNum">
							<el-input v-model="selectForm.carNum" placeholder="请输入车牌号" clearable></el-input>
						</el-form-item>
						<el-form-item label="车位号：" prop="lotId">
							<el-input v-model="selectForm.lotId" placeholder="请输入车位号" clearable></el-input>
						</el-form-item>
						<el-form-item label="当前状态：" prop="state">
							<el-select v-model="selectForm.state" clearable>
								<el-option label="生效中" value="1"></el-option>
								<el-option label="过期" value="2"></el-option>
								<el-option label="禁用" value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getAll">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="goClear2">重置</el-button>
						</el-form-item>
            <el-form-item>
					<el-button type="primary" @click="openOtherPage();">缴费记录</el-button>
          <el-button type="primary" @click="exportParkingRecord()">导出</el-button>          
				</el-form-item>
						<!-- <el-form-item>
							<el-button type="primary" @click="goAdd">新增</el-button>
						</el-form-item> -->
					</el-form>
				</div>
				<el-table :data="rcList" style="width: 100%" border v-loading="loading">
					<el-table-column prop="roomId" label="房间号" align="center"></el-table-column>
					<el-table-column prop="userName" label="车主姓名" align="center"></el-table-column>
          <el-table-column prop="auxiliaryInfo" label="业主单位" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
					<el-table-column prop="carType" label="车牌类型" align="center"></el-table-column>
					<el-table-column prop="carNum" label="车牌号" align="center"></el-table-column>
					<el-table-column prop="lotId" label="车位号" align="center"></el-table-column>
					<!-- <el-table-column prop="rent" label="租金" align="center"> -->
					<!-- </el-table-column> -->
					<el-table-column prop="time" label="租赁时长" align="center">
						<!-- <template slot-scope="{row}">
							{{ setTime(row.startTime) }}/{{ setTime(row.endTime) }}
						</template> -->
					</el-table-column>
					<el-table-column prop="state" label="当前状态" align="center">
            		<template slot-scope="{row}">
							{{row.state==1?'生效中':row.state==2?'过期':'禁用'}}
						</template>
					</el-table-column>
          <el-table-column prop="cardState" label="车牌状态" align="center">
            		<template slot-scope="{row}">
							{{row.cardState==1?'启动':'禁用'}}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click="viewRow(scope.row)">查看</el-button>
							<!-- <el-button type="text" @click="delRow(scope.row)">删除</el-button> -->
						</template>

					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
					:page-size="selectForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
					style="margin-top: 10px;">
				</el-pagination>
			</el-tab-pane>


      <el-tab-pane label="免费停车记录" name="4">
				<div>
					<el-form :inline="true" :model="selectForm4" ref="selectForm4">
            <el-form-item label="车牌号：" prop="plateNo">
							<el-input v-model="selectForm4.plateNo" placeholder="请输入车牌号" clearable></el-input>
						</el-form-item>
						<el-form-item label="车牌类型：" prop="carType">
							<el-input v-model="selectForm4.carType" placeholder="请输入车牌类型" clearable></el-input>
						</el-form-item>
						<el-form-item label="车辆类型：" prop="carStyle">
							<el-input v-model="selectForm4.carStyle" placeholder="请输入车辆类型" clearable></el-input>
						</el-form-item>
            <el-form-item label="进出场地点：" prop="capPlace">
							<el-input v-model="selectForm4.capPlace" placeholder="请输入进出场地点" clearable></el-input>
						</el-form-item>
            <el-form-item label="入场时间：">
              <el-date-picker style="width: 100%" clearable v-model="queryDate" type="datetimerange" align="right"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getAll">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="goClear4">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="rcList4" style="width: 100%" border v-loading="loading">
					<el-table-column prop="plateNo" label="车牌号" align="center"></el-table-column>
					<el-table-column prop="carType" label="车牌类型" align="center"></el-table-column>
					<el-table-column prop="carStyle" label="车辆类型" align="center"></el-table-column>
					<el-table-column prop="capPlace" label="进出场地" align="center"></el-table-column>
					<el-table-column prop="capTime" label="入场时间" align="center"></el-table-column>
					<el-table-column prop="imgInfo" label="图片信息" align="center">
            <template slot-scope="scope">
							<!-- <el-button type="text" @click="viewRow(scope.row)">查看</el-button> -->
						</template>
          </el-table-column>
					<el-table-column prop="operName" label="操作人" align="center"></el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
					:page-size="selectForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
					style="margin-top: 10px;">
				</el-pagination>
			</el-tab-pane>
		</el-tabs>

     <el-dialog :title="title" :visible.sync="viewShow" width="800px" >

      <el-table :data="viewList" style="width: 100%" v-loading="loadingView">
					<!-- <el-table-column prop="cardId" label="卡片ID" align="center"></el-table-column> -->
				
					<el-table-column prop="rechargeType" label="充值类型" align="center">
            <template slot-scope="{row}">
							{{row.rechargeType==0?`充值`:row.rechargeType==1?`退款`:`-`}}
						</template>
          </el-table-column>
					<el-table-column prop="rechargeState" label="充值状态" align="center">
            <template slot-scope="{row}">
            {{row.rechargeState==0?`未审核`:row.rechargeState==1?`审核`:row.rechargeState==2?`作废`:`已更新`}}
            </template>
          </el-table-column>
					<el-table-column prop="amount" label="支付金额" align="center"></el-table-column>
					<el-table-column prop="validFrom" label="开始时间" align="center"></el-table-column>
					<el-table-column prop="validTo" label="结束时间" align="center"></el-table-column>
          <el-table-column prop="chargeNumber" label="数值" align="center">
            <!-- <template slot-scope="{row}">
							{{row.chargeMethod==0?`${row.chargeNumber}分`:row.chargeMethod==1?`${row.chargeNumber}月`:row.chargeMethod==2?`${row.chargeNumber}天`:row.chargeMethod==3?`${row.chargeNumber}小时`:row.chargeMethod==4?`${row.chargeNumber}次`:`${row.chargeNumber}分`}}
						</template> -->
          </el-table-column>
          <el-table-column label="单位" align="center">
            <template slot-scope="{row}">
							{{row.chargeMethod==0?`分`:row.chargeMethod==1?`月`:row.chargeMethod==2?`天`:row.chargeMethod==3?`小时`:row.chargeMethod==4?`次`:`分`}}
						</template>
          </el-table-column>
				</el-table>
      </el-dialog>




      <el-dialog title="缴费记录" :visible.sync="otherPage" width="80%" :close-on-click-modal="false"
			 :modal-append-to-body="false">
			<el-form :inline="true" :model="selectOther" ref="selectOther">
            <el-form-item label="车主名称：" prop="userName">
							<el-input size="small" v-model="selectOther.userName" placeholder="请输入车主名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="手机号：" prop="userPhone">
							<el-input size="small" v-model="selectOther.userPhone" placeholder="请输入手机号" clearable></el-input>
						</el-form-item>
						<el-form-item label="车牌号：" prop="carNum">
							<el-input size="small" v-model="selectOther.carNum" placeholder="请输入车牌号" clearable></el-input>
						</el-form-item>
            <el-form-item label="车牌类型：" prop="carType">
							<el-input size="small" v-model="selectOther.carType" placeholder="请输入车牌类型" clearable></el-input>
						</el-form-item>
            <el-form-item label="充值时间：">
              <el-date-picker size="small" style="width: 100%" clearable v-model="otherTimeArr" type="datetimerange" align="right"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
					  </el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" @click="currentChangeOther(1)">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" @click="otherQuery">重置</el-button>
						</el-form-item>
            <el-form-item>
							<el-button size="small" type="primary" @click="otherExport">导出</el-button>
						</el-form-item>
					</el-form>
				<el-table :data="otherPageList" style="width: 100%" border v-loading="loading"
        :max-height="550">
					<el-table-column prop="userName" label="车主名称" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
					<el-table-column prop="carNum" label="车牌号" align="center"></el-table-column>
					<el-table-column prop="carType" label="车牌类型" align="center"></el-table-column>
					<el-table-column prop="amount" label="充值金额" align="center"></el-table-column>
					<el-table-column prop="chargeNumber" label="数值" align="center"></el-table-column>
          <el-table-column label="单位" align="center">
            <template slot-scope="{row}">
							{{row.chargeMethod==0?`分`:row.chargeMethod==1?`月`:row.chargeMethod==2?`天`:row.chargeMethod==3?`小时`:row.chargeMethod==4?`次`:`分`}}
						</template>
          </el-table-column>
          <el-table-column prop="validFrom" label="充值时间" align="center"></el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-pagination v-if="otherTotalNum>0" @size-change="sizeChangeOther" @current-change="currentChangeOther" :page-sizes="[10, 20, 30, 40]"
          :current-page.sync="selectOther.currentPage"  :page-size="selectOther.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="otherTotalNum"
					style="margin-top: 10px;">
				</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
import { param } from "../../utils/index.js";
export default {
  data() {
    return {
      otherTimeArr: [],
      otherPage: false,
      otherTotalNum: 0,
      selectOther: {
        //查询条件
        currentPage: 1,
        pageSize: 10, //页大小
        userName: null,
        userPhone: null,
        carNum: null,
        startTime: null,
        endTime: null,
      },
      otherPageList: [],
      otherLoading: false,
      loadingView: false,
      viewList: [],
      viewShow: false,
      loading: false,
      tcSelect: {
        startTime: null,
        endTime: null,
        parkingLot: null,
        carNum: null,
        currentPage: 1,
        pageSize: 10,
      },
      oldtcSelect: {},
      sum: null,
      tcList: [],
      rcList: [],
      rcList4: [],
      headerData: {
        Authorization: localStorage.access_token,
      },
      activeName: "2",
      form: {
        //表单数据
        name: "",
        age: "",
      },
      queryDate: [],
      oldForm: undefined, //表单备份数据
      data: [], //表格数据
      selectForm: {
        //查询条件
        currentPage: 1, //当前页
        pageSize: 10, //页大小
        userName: null,
        roomId: null,
        userPhone: null,
        carNum: null,
        lotId: null,
        state: null,
        cardState: null,
      },
      selectForm4: {
        //查询条件
        currentPage: 1, //当前页
        pageSize: 10, //页大小
        operName: null,
        plateNo: null,
        carType: null,
        carStyle: null,
        capPlace: null,
        // capTime: null,
        startTime: null,
        endTime: null,
      },
      oldSelectForm4: {},
      oldSelectForm: {},
      totalNum: 0, //数据总数
      show: false, //控制弹窗
      title: "",
      disable: false, //节流
      yzlist: [],
      isChange: false,
      rules: {
        statu: [
          {
            required: true,
            message: "结清状态不能为空",
            trigger: ["blur", "change"],
          },
        ],
        unitName: [
          {
            required: true,
            message: "单位名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        property: [
          {
            required: true,
            message: "缴费模式不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      isXx: {
        roomNum: null,
        name: null,
        phone: null,
        carNum: null,
        spaceNum: null,
        rent: null,
        startTime: null,
        endTime: null,
      },
      oldisXx: {},
    };
  },
  methods: {
    sizeChangeOther(size) {
      //页大小被修改
      this.selectOther.pageSize = size;
      this.getOtherAll();
    },
    currentChangeOther(page) {
      this.selectOther.currentPage = page;
      this.getOtherAll();
    },
    getOtherAll() {
      this.otherLoading = true;
      if (this.otherTimeArr && this.otherTimeArr.length == 2) {
        this.selectOther.startTime = this.otherTimeArr[0];
        this.selectOther.endTime = this.otherTimeArr[1];
      } else {
        this.selectOther.startTime = null;
        this.selectOther.endTime = null;
      }
      if (this.selectOther.userName == "") {
        this.selectOther.userName = null;
      }
      if (this.selectOther.userPhone == "") {
        this.selectOther.userPhone = null;
      }
      if (this.selectOther.carNum == "") {
        this.selectOther.carNum = null;
      }
      if (this.selectOther.carType == "") {
        this.selectOther.carType = null;
      }

      this.$http
        .post("/api/bdTingCheOrder/queryParkingPay", this.selectOther)
        .then((res) => {
          this.otherLoading = false;
          if (res.data.code == 0) {
            this.otherPageList = res.data.data.items;
            this.otherTotalNum = res.data.data.totalNum;
          } else {
            this.otherPageList = [];
            this.otherTotalNum = 0;
          }
        });
    },
    otherQuery() {
      this.otherTimeArr = [];
      this.selectOther = {
        //查询条件
        currentPage: 1,
        pageSize: 10, //页大小
        userName: null,
        userPhone: null,
        carNum: null,
        startTime: null,
        endTime: null,
      };
      this.getOtherAll();
    },
    exportParkingRecord(){
      publicExport(
        "/api/bdTingCheOrder/exportParkingInfo",
        this.selectForm,
        "车位租赁记录"
      );
    },
    otherExport(){
      publicExport(
        "/api/bdTingCheOrder/exportParkingPay",
        this.selectOther,
        "缴费记录"
      );
    },
    openOtherPage() {
      this.otherPage = true;
      this.otherQuery();
    },
    query() {
      this.tcSelect.currentPage = 1;
      this.selectForm.currentPage = 1;
      this.totalNum = 0;
      this.getAll();
    },
    dc() {
      //console.log('tcSelect:',JSON.stringify(this.tcSelect))
      publicExport(
        "/api/bdTingCheOrder/exportTingCheOrder",
        this.tcSelect,
        "停车管理记录"
      );
    },

    goAdd() {
      this.isXx = JSON.parse(JSON.stringify(this.oldisXx));
      this.title = "新增";
      this.isChange = true;
    },
    confirmClick() {
      if (this.title == "新增") {
        this.$http
          .post("/api/carSpaceRental/addCarSpaceRental", {
            ...this.isXx,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.isChange = false;
              this.getAll();
            }
            console.log(res);
          });
      } else {
        this.$http
          .post("/api/carSpaceRental/updateCarSpaceRental", {
            ...this.isXx,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.isChange = false;
              this.getAll();
            }
            console.log(res);
          });
      }
    },

    handleClose() {
      this.isChange = false;
    },
    getYzList() {
      this.$http.get("/api/ownerManage/getOwners").then((res) => {
        console.log(res);
        this.yzlist = res.data.data;
      });
    },
    ok() {
      this.disable = true;
      let url = "/api/set";
      if (this.title[0] == "新") {
        url = "/api/add";
      }
      this.$http.post(url, this.form).then((res) => {
        this.disable = false;
        if (res.data.code == 0) {
          this.show = false;
          this.$message.success(`${this.title}成功`);
          this.getAll();
        } else {
          this.$message.error(`${this.title}失败`);
        }
      });
    },
    delRow(row) {
      //删除被点击
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/carSpaceRental/deleteCarSpaceRental", {
              params: {
                id: row.id,
              },
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.getAll();
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    viewRow(row) {
      this.viewList = [];
      this.title = "缴费记录";
      this.loadingView = true;
      this.viewShow = true;

      this.$http
        .get("/api/bdTingCheOrder/getParkingPay?cardId=" + row.cardId)
        .then((res) => {
          this.loadingView = false;
          if (res.data.code == 0) {
            this.viewList = res.data.data;
          }
        });
    },
    setRow(row) {
      //修改被点击
      this.title = "修改";
      this.isChange = true;
      this.isXx = {
        ...row,
      };
    },
    close() {
      //弹框关闭
      this.$refs.form.resetFields();
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    getAll() {
      this.loading = true;
      //获取表格数据
      if (this.activeName == 1) {
        if (this.selectForm.userName == "") {
          this.selectForm.userName = null;
        }
        if (this.selectForm.roomId == "") {
          this.selectForm.roomId = null;
        }
        if (this.selectForm.userPhone == "") {
          this.selectForm.userPhone = null;
        }
        if (this.selectForm.carNum == "") {
          this.selectForm.carNum = null;
        }
        if (this.selectForm.lotId == "") {
          this.selectForm.lotId = null;
        }
        if (this.selectForm.state == "") {
          this.selectForm.state = null;
        }

        this.$http
          // .post("/api/carSpaceRental/queryCarSpaceRental", {
          .post("/api/bdTingCheOrder/getParkingInfo", {
            ...this.selectForm,
          })
          .then((res) => {
            this.loading = false;
            this.rcList = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
            // this.sum=res.data.data.sum
            console.log(res);
          });
      } else if (this.activeName == 2) {
        this.$http
          .post("/api/bdTingCheOrder/queryTingCheOrder", {
            ...this.tcSelect,
          })
          .then((res) => {
            this.loading = false;
            this.tcList = res.data.data.page.items;
            this.totalNum = res.data.data.page.totalNum;
            this.sum = res.data.data.sum;
            console.log(res);
          });
      } else if (this.activeName == 4) {
        if (this.queryDate && this.queryDate.length == 2) {
          this.selectForm4.startTime = this.queryDate[0];
          this.selectForm4.endTime = this.queryDate[1];
        } else {
          this.selectForm4.startTime = null;
          this.selectForm4.endTime = null;
        }
        this.$http
          .post("/api/bdTingCheOrder/getFreeParkingInfo", {
            ...this.selectForm4,
          })
          .then((res) => {
            this.loading = false;
            this.rcList4 = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
          });
      }
    },
    goClear4() {
      this.queryDate = [];
      this.selectForm4 = JSON.parse(JSON.stringify(this.oldSelectForm4));
      this.getAll();
    },
    goClear2() {
      this.selectForm = JSON.parse(JSON.stringify(this.oldSelectForm));
      this.getAll();
    },
    goClear() {
      this.tcSelect = JSON.parse(JSON.stringify(this.oldtcSelect));
      this.getAll();
    },
    sizeChange(size) {
      //页大小被修改
      this.tcSelect.pageSize = size;
      this.selectForm.pageSize = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      console.log("page : ", page);
      this.tcSelect.currentPage = page;
      this.selectForm.currentPage = page;
      this.getAll();
    },
  },
  mounted() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    this.oldtcSelect = JSON.parse(JSON.stringify(this.tcSelect));

    this.oldSelectForm = JSON.parse(JSON.stringify(this.selectForm));
    this.oldSelectForm4 = JSON.parse(JSON.stringify(this.selectForm4));
    this.oldisXx = JSON.parse(JSON.stringify(this.isXx));
    this.getYzList();
    this.getAll();
  },
};
</script>

<style></style>
